import { useLocation } from "react-router-dom";

function ErrorPage() {
  const location = useLocation();
  const { message, status } = location.state || { message: "Unknown error occurred", status: 500 };

  return (
    <div>
      <h1>Error {status}</h1>
      <p>{message}</p>
    </div>
  );
}

export default ErrorPage;
